import type { NewsItem } from "@/types/media";

export const newsItems: NewsItem[] = [
  {
    id: "news-summer-box",
    title: "2025暑期档票房盘点：多部现实题材影片逆势上扬",
    summary:
      "今年暑期档总票房再创新高，现实题材与科幻类型表现亮眼，观众对优质内容的付费意愿持续提升。",
    content: [
      "随着暑期档正式收官，今年的票房成绩单也浮出水面。据唐心影视观察整理的数据显示，暑期档总票房较去年同期稳步增长，观影人次亦有明显提升，显示出观众走进影院的意愿正在持续恢复。",
      "题材方面，现实题材影片成为最大赢家。多部聚焦普通人生活、家庭关系与成长困境的作品凭借真实的情感表达赢得口碑，并在社交平台引发广泛讨论。与此同时，科幻类型同样表现亮眼，视效水准与叙事完成度均较往年有明显进步。",
      "业内人士分析认为，观众对优质内容的付费意愿正在增强，内容品质而非单纯的明星阵容，正成为决定一部作品成败的关键因素。这一趋势也促使更多创作者将重心放回故事本身。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20cinema%20with%20glowing%20marquee%20signs%20at%20night%2C%20warm%20amber%20and%20navy%20tones%2C%20editorial%20film%20industry%20photography%2C%20cinematic%20atmosphere&width=800&height=450&seq=tangxin-news-01&orientation=landscape",
    date: "2025-09-08",
    source: "唐心影视观察",
    tag: "行业",
  },
  {
    id: "news-changfeng-hot",
    title: "古装剧《长风渡口》口碑走高，年代叙事获观众好评",
    summary:
      "该剧凭借细腻的人物刻画与诗意的镜头语言，成为近期讨论度最高的年代剧之一。",
    content: [
      "由沈砚舟执导的年代剧《长风渡口》开播以来口碑持续走高，凭借扎实的剧本与克制的叙事风格收获了大量好评，成为近期讨论度最高的年代剧之一。",
      "该剧以一条古渡为线索，串联起几户人家的命运沉浮，没有夸张的戏剧冲突，而是用细节还原时代的质感。晨雾中的江面、黄昏里的乌篷船，都被拍得极具诗意，被观众称为“可以截图当壁纸的剧”。",
      "演员方面的表现同样可圈可点，几位主演用细腻的表演诠释了角色在时代洪流中的挣扎与坚守，让观众在追剧之余也对那段历史产生了更深的兴趣。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Misty%20ancient%20riverside%20town%20at%20golden%20dawn%20with%20wooden%20boats%2C%20warm%20golden%20haze%2C%20historical%20drama%20atmosphere%2C%20cinematic%20editorial%20photography&width=800&height=450&seq=tangxin-news-02&orientation=landscape",
    date: "2025-09-02",
    source: "唐心剧集",
    tag: "剧集",
  },
  {
    id: "news-filmfestival",
    title: "亚洲电影展落幕，多部华语新片斩获重要奖项",
    summary:
      "本届影展聚焦新锐导演作品，多部华语电影在剧情、摄影等单元获得认可，新人力量备受瞩目。",
    content: [
      "为期数天的亚洲电影展日前落下帷幕。本届影展将目光投向新锐导演，多部来自华语地区的新片在主竞赛单元获得提名，并在剧情、摄影等技术单元有所斩获。",
      "评委会表示，今年的入选作品在题材探索与影像语言上都展现出了令人惊喜的创造力，尤其是几部小成本影片，用有限的资源讲述出了极具个人风格的故事，令人印象深刻。",
      "影展期间还举办了多场映后交流与行业论坛，创作者们围绕“如何讲好本土故事”展开了讨论。不少新人导演表示，这样的平台为他们的作品提供了被看见的机会。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20film%20festival%20red%20carpet%20with%20warm%20spotlights%20at%20night%2C%20sophisticated%20award%20ceremony%20atmosphere%2C%20cinematic%20editorial%20photography&width=800&height=450&seq=tangxin-news-03&orientation=landscape",
    date: "2025-08-26",
    source: "唐心影视观察",
    tag: "行业",
  },
  {
    id: "news-wudu-mian",
    title: "悬疑剧《雾都迷案》收官，开放式结局引发全网讨论",
    summary:
      "该剧以扎实的推理和浓厚的氛围感圈粉无数，大结局的处理方式更是登上多个平台热搜。",
    content: [
      "悬疑剧《雾都迷案》日前迎来收官。该剧以一段被尘封的旧案为核心，通过双线叙事层层揭开真相，扎实的推理逻辑与浓厚的氛围感让它成为今年口碑最好的悬疑剧之一。",
      "值得一提的是，该剧在大结局的处理上并未给出一个直白的答案，而是留下了开放的解读空间。这一处理方式迅速登上多个平台热搜，观众围绕结局的多种可能展开了热烈讨论。",
      "导演傅寒声在采访中表示，悬疑只是外壳，真正想探讨的是正义、亲情与救赎。“有时候观众需要的不是一个标准答案，而是一次思考。”",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20night%20city%20street%20with%20warm%20streetlamp%20glow%20and%20teal%20mist%2C%20mysterious%20crime%20thriller%20atmosphere%2C%20cinematic%20editorial%20photography&width=800&height=450&seq=tangxin-news-04&orientation=landscape",
    date: "2025-08-19",
    source: "唐心剧集",
    tag: "剧集",
  },
  {
    id: "news-shijian-zhouzhe",
    title: "科幻新片《时间褶皱》定档，时间题材再掀观影热潮",
    summary:
      "影片凭借精巧的叙事结构与震撼的视觉呈现未映先热，被不少影迷列入年度期待片单。",
    content: [
      "备受期待的科幻电影《时间褶皱》正式宣布定档。影片讲述一位物理学家发现“时间褶皱”、并为挽回一场告别而冒险折叠时间的故事，未映先热，被不少影迷列入年度期待片单。",
      "从此前放出的物料来看，影片在视觉呈现上极具野心。扭曲的城市天际线、折叠的空间走廊、逆流而下的雨水，构成了一幅幅超现实的画面，被评价为“把时间悖论拍成了视觉艺术”。",
      "业内人士认为，近年时间题材作品持续走热，反映出观众对高概念叙事的接受度不断提高，而《时间褶皱》有望成为该题材的又一代表作。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20glowing%20time%20portal%20with%20geometric%20light%20paths%20in%20dark%20space%2C%20amber%20and%20navy%20tones%2C%20science%20fiction%20editorial%20photography&width=800&height=450&seq=tangxin-news-05&orientation=landscape",
    date: "2025-08-11",
    source: "唐心电影",
    tag: "电影",
  },
  {
    id: "news-xingyu-shaonian",
    title: "动画电影《星屿少年》幕后揭秘：手绘星海的诞生",
    summary:
      "制作团队首次公开影片的美术手稿与制作流程，数百位画师历时三年打磨每一帧画面。",
    content: [
      "动画电影《星屿少年》近日公开了幕后制作纪录，首次展示了影片的美术手稿与完整制作流程。数百位画师历时三年，用一帧帧手绘还原了那座漂浮于星海之上的奇幻岛屿。",
      "据制作团队介绍，影片中的每一片星云、每一朵云桥都经过反复打磨。为了呈现少年出发时的辽阔感，团队在色彩与构图上参考了大量自然与天文影像，最终形成了独特而统一的视觉风格。",
      "导演叶知秋表示，希望这部作品能让孩子看到冒险的勇气，也能让成年观众想起自己出发时的初心。影片目前正在热映中。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Hand-painted%20animated%20floating%20island%20under%20starry%20night%20sky%2C%20teal%20ocean%20and%20golden%20stars%2C%20whimsical%20animation%20artwork&width=800&height=450&seq=tangxin-news-06&orientation=landscape",
    date: "2025-08-05",
    source: "唐心电影",
    tag: "电影",
  },
  {
    id: "news-interview",
    title: "专访导演傅寒声：悬疑故事的内核永远是人心",
    summary:
      "从《雾都迷案》的创作谈开去，导演分享了他对悬疑类型、人物塑造与观众期待的理解。",
    content: [
      "在悬疑剧《雾都迷案》收官之际，唐心专访了导演傅寒声。从剧本创作到拍摄现场，他详细讲述了这部剧背后的思考与选择。",
      "谈到悬疑类型的创作，傅寒声认为最重要的不是制造悬念，而是让人物立得住。“观众会忘记凶手是谁，但会记住角色为什么会那样选择。”他坦言，团队在人物小传上花费的时间，甚至超过了案情的推演。",
      "对于观众对开放式结局的热议，傅寒声表示这正是他想要的：“悬疑故事的内核永远是人心。留下一点空间，让观众自己去完成它，是很有趣的一件事。”",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20interview%20setting%20with%20director%20chair%20and%20warm%20studio%20lighting%2C%20editorial%20portrait%20atmosphere%2C%20cinematic%20photography&width=800&height=450&seq=tangxin-news-07&orientation=landscape",
    date: "2025-07-28",
    source: "唐心访谈",
    tag: "访谈",
  },
  {
    id: "news-autumn-drama",
    title: "秋季新剧前瞻：都市、悬疑、年代三分天下",
    summary:
      "多部备受期待的新剧即将登陆，题材覆盖都市情感、悬疑推理与年代史诗，看点十足。",
    content: [
      "进入秋季，多部备受期待的新剧即将陆续登陆。从目前公开的片单来看，都市情感、悬疑推理与年代史诗三大题材几乎平分秋色，看点十足。",
      "都市题材方面，多部作品将镜头对准年轻人的职场与生活，试图捕捉当下城市青年的真实状态；悬疑推理方面则有多部高概念作品蓄势待发，主创阵容与制作水准都颇具看点。",
      "年代史诗同样值得期待，几部大制作的服化道与场景还原都投入了大量心血。可以预见，这个秋天观众将有不少好剧可以慢慢追。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Autumn%20city%20scene%20with%20warm%20falling%20leaves%20and%20golden%20light%2C%20seasonal%20editorial%20film%20atmosphere%2C%20cinematic%20photography&width=800&height=450&seq=tangxin-news-08&orientation=landscape",
    date: "2025-07-20",
    source: "唐心剧集",
    tag: "剧集",
  },
];